import _ from 'lodash';
import { combineReducers } from 'redux';
import { createSelector } from 'reselect';

import SimcInput from 'shared/simcinput';

import { setterReducer, toggleReducer } from 'frontend/state/utils';
import types from 'frontend/state/actionTypes';

export default combineReducers({
  simcExpertMode: toggleReducer({
    toggle: types.TOGGLE_SIMC_EXPERT_MODE,
    initial: false,
  }),
  header: setterReducer({
    set: types.INPUT_EXPERT_HEADER,
    initial: '',
  }),
  preActors: setterReducer({
    set: types.INPUT_EXPERT_PRE_ACTORS,
    initial: '',
  }),
  raidActors: setterReducer({
    set: types.INPUT_EXPERT_RAID_ACTORS,
    initial: '',
  }),
  postActors: setterReducer({
    set: types.INPUT_EXPERT_POST_ACTORS,
    initial: '',
  }),
  footer: setterReducer({
    set: types.INPUT_EXPERT_FOOTER,
    initial: '',
  }),
});

const baseSelector = state => state.simbot.simcExpertOptions;
const simcExpertModeSelector = state => baseSelector(state).simcExpertMode;
const headerSelector = state => baseSelector(state).header;
const preActorsSelector = state => baseSelector(state).preActors;
const raidActorsSelector = state => baseSelector(state).raidActors;
const postActorsSelector = state => baseSelector(state).postActors;
const footerSelector = state => baseSelector(state).footer;

const returnInputIfExpertEnabled = (expertMode, input) => {
  if (expertMode) {
    return input;
  }
  return undefined;
};

const inputToData = input => SimcInput.parse(input);

const headerInputSelector = createSelector(
  simcExpertModeSelector,
  headerSelector,
  returnInputIfExpertEnabled,
);
const headerDataSelector = createSelector(
  headerInputSelector,
  inputToData,
);

const preActorsInputSelector = createSelector(
  simcExpertModeSelector,
  preActorsSelector,
  returnInputIfExpertEnabled,
);
const preActorsDataSelector = createSelector(
  preActorsInputSelector,
  inputToData,
);

const raidActorsInputSelector = createSelector(
  simcExpertModeSelector,
  raidActorsSelector,
  returnInputIfExpertEnabled,
);
const raidActorsDataSelector = createSelector(
  raidActorsInputSelector,
  inputToData,
);

const postActorsInputSelector = createSelector(
  simcExpertModeSelector,
  postActorsSelector,
  returnInputIfExpertEnabled,
);
const postActorsDataSelector = createSelector(
  postActorsInputSelector,
  inputToData,
);

const footerInputSelector = createSelector(
  simcExpertModeSelector,
  footerSelector,
  returnInputIfExpertEnabled,
);
const footerDataSelector = createSelector(
  footerInputSelector,
  inputToData,
);

const isExpertActiveSelector = createSelector(
  headerInputSelector,
  preActorsInputSelector,
  raidActorsInputSelector,
  postActorsInputSelector,
  footerInputSelector,
  (header, preActors, raidActors, postActors, footer) => {
    return Boolean(header || preActors || raidActors || postActors || footer);
  },
);

const numExpertActorsSelector = createSelector(
  headerDataSelector,
  preActorsDataSelector,
  raidActorsDataSelector,
  postActorsDataSelector,
  footerDataSelector,
  (...data) => {
    return _.sum(_.map(data, d => SimcInput.getActors(d).length));
  },
);

export const selectors = {
  simcExpertMode: simcExpertModeSelector,
  header: headerSelector,
  preActors: preActorsSelector,
  raidActors: raidActorsSelector,
  postActors: postActorsSelector,
  footer: footerSelector,

  headerInput: headerInputSelector,
  preActorsInput: preActorsInputSelector,
  raidActorsInput: raidActorsInputSelector,
  postActorsInput: postActorsInputSelector,
  footerInput: footerInputSelector,

  headerData: headerDataSelector,
  preActorsData: preActorsDataSelector,
  raidActorsData: raidActorsDataSelector,
  postActorsData: postActorsDataSelector,
  footerData: footerDataSelector,

  numExpertActors: numExpertActorsSelector,

  isExpertActive: isExpertActiveSelector,
};
